import { pb } from './pocketbase';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

export const getOpcos = async () => {
    try {
        // Récupérer tous les OPCO depuis PocketBase
        const records = await pb.collection('opcos').getFullList({
            sort: 'name'
        });

        return records.map(record => ({
            id: record.id,
            name: record.name,
            code: record.code,
            description: record.description || '',
            active: record.active !== false // Par défaut true si non défini
        }));

    } catch (error) {
        console.error('Erreur lors de la récupération des OPCO:', error);
        throw new Error('Impossible de récupérer la liste des OPCO');
    }
};

export const getOpcoOptions = async () => {
    try {
        const opcos = await getOpcos();
        
        return opcos
            .filter(opco => opco.active) // Filtrer seulement les OPCO actifs
            .map(opco => ({
                value: opco.id,
                label: opco.name,
                code: opco.code
            }));

    } catch (error) {
        console.error('Erreur lors de la récupération des options OPCO:', error);
        return [];
    }
};

export const statusFolderOpco = async (folderId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/contracts/status-folder-opco`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
      },
      body: JSON.stringify({ folderId }),
    });
    
    if (!response.ok) {
      throw new Error('Erreur lors de la récupération du statut OPCO');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Erreur lors de la récupération du statut OPCO:', error);
    throw error;
  }
};

export const sendToOpco = async (folderId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/contracts/send-folder-opco`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
      },
      body: JSON.stringify({ folderId }),
    });
    
    if (!response.ok) {
      throw new Error('Erreur lors de l\'envoi au opco');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Erreur lors de l\'envoi au opco:', error);
    throw error;
  }
};

export const sendConventionToOpco = async (folderId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/contracts/send-convention-opco`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
      },
      body: JSON.stringify({ folderId }),
    });
    
    if (!response.ok) {
      throw new Error('Erreur lors de l\'envoi au opco');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Erreur lors de l\'envoi au opco:', error);
    throw error;
  }
};
